import StoreBenefits from 'components/Blocks/Store/StoreBenefits/StoreBenefits';

export default StoreBenefits;
